module.exports = __webpack_public_path__ + "static/media/5.1c53291b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/5.png
// module id = 195
// module chunks = 6